export class NextStepsAfterTriageProtocol {
    public idNextStepsAfterTriageProtocol: number;
    public nextStepsAfterTriageProtocolDescription: string;
    public idCareLinePriority: number;
}